import { atom } from "jotai";

export const apiInitializedAtom = atom(false);
